// extracted by mini-css-extract-plugin
export default {"limitWrapper":"Input_limitWrapper__Y64DA","inputWrapper":"Input_inputWrapper__wPv9x","input":"Input_input__ZdNmD","limit":"Input_limit__+Bx+E"};